export default "__VITE_ASSET__BSM0h2Jp__"